export const REQUEST_LOADER = 'FETCH_LOGIN_USER_REQUEST';
export const RESET = 'RESET';
